import { Routes } from "ui/modules/notifications/navigation/routes";

export const CALENDAR_TABS: { route: string; icon: string; label: string }[] = [
  {
    route: Routes.NotificationCalendarPageRouter,
    icon: "/media/icons/calendar.svg",
    label: "admin.notification.calendar.tab.calendar",
  },
  {
    route: Routes.NotificationVehicleTimelinePageRouter,
    icon: "/media/icons/vehicle.svg",
    label: "admin.notification.calendar.tab.timeline",
  },
];
